import { formatVolumeCell } from 'utils/helpers/format';

const inventorySummaryColumns = [
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    hide: false,
    sortable: true,
    width: 200,
  },
  {
    field: 'locationName',
    headerName: 'Location Name',
    hide: false,
    sortable: true,
    width: 200,
  },
  {
    field: 'inTransitVolume',
    headerName: 'Intransit Vol. (bbls)',
    hide: false,
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 200,
  },
  {
    field: 'availableVolume',
    headerName: 'Available Vol. (bbls)',
    hide: false,
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 200,
  },
  {
    field: 'totalVolume',
    headerName: 'Total Vol. (bbls)',
    hide: false,
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 200,
  },
  {
    field: 'daysSupply',
    headerName: 'Days Supply',
    hide: false,
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 200,
  },
];

export default inventorySummaryColumns;
